module.exports = __webpack_public_path__ + "img/logo_1.dcbd010b.png";